import { createContext, useCallback, useMemo, useState } from "react";
import type { AthleteOrGroup } from "types/AthleteOrGroup";

export interface FilterAthletesOrGroupsType {
  value: AthleteOrGroup | null;
}

export const FilterAthletesOrGroupsContext = createContext<FilterAthletesOrGroupsType | undefined>(undefined);
FilterAthletesOrGroupsContext.displayName = "FilterAthletesOrGroupsContext";

export interface FilterAthletesOrGroupsActionsType {
  onSetValue: (newValue: AthleteOrGroup | null) => void;
  onClearValue: () => void;
}

export const FilterAthletesOrGroupsActionsContext = createContext<FilterAthletesOrGroupsActionsType | undefined>(
  undefined
);
FilterAthletesOrGroupsActionsContext.displayName = "FilterAthletesOrGroupsActionsContext";

interface FilterAthletesOrGroupsProviderProps {
  children?: React.ReactNode;
}

function FilterAthletesOrGroupsProvider(props: FilterAthletesOrGroupsProviderProps) {
  const [value, setValue] = useState<AthleteOrGroup | null>(null);

  const onSetValue = useCallback((newValue: AthleteOrGroup | null) => {
    setValue(newValue);
  }, []);

  const onClearValue = useCallback(() => {
    setValue(null);
  }, []);

  const contextValue: FilterAthletesOrGroupsType = useMemo(() => ({ value }), [value]);
  const actions = useMemo(() => ({ onSetValue, onClearValue }), [onSetValue, onClearValue]);

  return (
    <FilterAthletesOrGroupsContext.Provider value={contextValue}>
      <FilterAthletesOrGroupsActionsContext.Provider value={actions}>
        {props.children}
      </FilterAthletesOrGroupsActionsContext.Provider>
    </FilterAthletesOrGroupsContext.Provider>
  );
}

export default FilterAthletesOrGroupsProvider;
